var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10137IconServiceCacheRedis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a4c0a6df-707e-4ae7-9b86-742e4f9651e0",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac420e47-f190-46df-ab14-7e1f8fa3a93d",
    x1: 9.5,
    y1: 7.37,
    x2: 17.5,
    y2: 7.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a51ffd84-af0a-457a-abee-1f70656da56f",
    x1: 0.5,
    y1: 7.37,
    x2: 8.5,
    y2: 7.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbb4b87e-b1f0-4042-b6d6-9b91b5dac799",
    x1: 5,
    y1: 11.9,
    x2: 13,
    y2: 11.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-databases-137") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,4.62c-2.21,0-4-.57-4-1.28v6.79c0,.69,1.76,1.26,3.95,1.27h.05c2.21,0,4-.57,4-1.27V3.34C17.5,4.05,15.71,4.62,13.5,4.62Z",
    fill: "url(#ac420e47-f190-46df-ab14-7e1f8fa3a93d)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,3.34c0,.71-1.79,1.28-4,1.28s-4-.57-4-1.28,1.79-1.27,4-1.27,4,.57,4,1.27",
    fill: "#e8e8e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.57,3.24c0,.45-1.38.81-3.07.81s-3.07-.36-3.07-.81,1.38-.81,3.07-.81,3.07.36,3.07.81",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,3.43a8.65,8.65,0,0,0-2.43.3,7.8,7.8,0,0,0,2.43.32,7.8,7.8,0,0,0,2.43-.32A8.65,8.65,0,0,0,13.5,3.43Z",
    fill: "#32bedd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,4.62c-2.21,0-4-.57-4-1.28v6.79c0,.69,1.76,1.26,4,1.27h0c2.21,0,4-.57,4-1.27V3.34C8.5,4.05,6.71,4.62,4.5,4.62Z",
    fill: "url(#a51ffd84-af0a-457a-abee-1f70656da56f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,3.34c0,.71-1.79,1.28-4,1.28s-4-.57-4-1.28,1.79-1.27,4-1.27,4,.57,4,1.27",
    fill: "#e8e8e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57,3.24c0,.45-1.38.81-3.07.81s-3.07-.36-3.07-.81,1.38-.81,3.07-.81,3.07.36,3.07.81",
    fill: "#50e6ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,3.43a8.65,8.65,0,0,0-2.43.3,7.8,7.8,0,0,0,2.43.32,7.8,7.8,0,0,0,2.43-.32A8.65,8.65,0,0,0,4.5,3.43Z",
    fill: "#32bedd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,9.15c-2.21,0-4-.57-4-1.28v6.79c0,.7,1.76,1.26,3.95,1.27H9c2.21,0,4-.57,4-1.27V7.87C13,8.58,11.21,9.15,9,9.15Z",
    fill: "url(#bbb4b87e-b1f0-4042-b6d6-9b91b5dac799)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,7.87c0,.71-1.79,1.28-4,1.28S5,8.58,5,7.87,6.79,6.6,9,6.6s4,.57,4,1.27",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.07,7.77c0,.45-1.38.81-3.07.81s-3.07-.36-3.07-.81S7.31,7,9,7s3.07.36,3.07.81",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,8a8.65,8.65,0,0,0-2.43.3A7.8,7.8,0,0,0,9,8.58a7.8,7.8,0,0,0,2.43-.32A8.65,8.65,0,0,0,9,8Z",
    fill: "#32bedd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10137IconServiceCacheRedis);
export default __webpack_public_path__ + "static/media/10137-icon-service-Cache-Redis.de01f22810029e7ed9aa481d6583e429.svg";
export { ForwardRef as ReactComponent };